import styled from "styled-components"

import { Skeleton, spacing, Text } from "@minuthq/meatball-ui-react"

import { useFetchTasksCount } from "src/data/taskManagement/hooks/useTaskCount"
import { useTranslate } from "src/i18n/useTranslate"
import { MCardInteractive } from "src/ui/MCard/MCardInteractive"

export function TaskCards() {
  const { tPlaceholder } = useTranslate()

  const { count: todoTasksCount, loading: loadingTodoTasks } =
    useFetchTasksCount({ statuses: ["todo"] })
  const { count: completedTasksCount, loading: loadingCompletedTasks } =
    useFetchTasksCount({ statuses: ["done"] })

  return (
    <CardBox>
      <TaskCard
        title={tPlaceholder("To do tasks")}
        number={todoTasksCount}
        description={tPlaceholder("Tasks awaiting completion")}
        loading={loadingTodoTasks}
      />
      <TaskCard
        title={tPlaceholder("Completed tasks")}
        number={completedTasksCount}
        description={tPlaceholder("Successfully completed tasks")}
        loading={loadingCompletedTasks}
      />
    </CardBox>
  )
}

function TaskCard({
  title,
  number,
  description,
  loading,
}: {
  title: string
  number: number
  description: string
  loading?: boolean
}) {
  return (
    <MCardInteractive padding="m">
      <div>
        <Text variant="subtitle">{title}</Text>
        {loading ? (
          <Skeleton variant="text" width={"3ch"} height={40} />
        ) : (
          <Text variant="heading2">{number}</Text>
        )}
        <Text variant="bodyS" color="tertiary">
          {description}
        </Text>
      </div>
    </MCardInteractive>
  )
}

const CardBox = styled.div`
  display: grid;
  grid-gap: ${spacing.M};
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-auto-rows: 1fr;
  margin-bottom: ${spacing.L};
`
